import { PathNames } from 'src/shared/enum/PathNames';

export const routes = {
    index: PathNames.ROOT,

    summary: {
        index: PathNames.SUMMARY,
    },

    yourDetails: {
        index: PathNames.YOUR_DETAILS,
    },

    roommates: {
        index: PathNames.ROOMMATES,
    },

    agreements: {
        index: PathNames.AGREEMENTS,
    },

    success: {
        index: PathNames.SUCCESS,
        oria: PathNames.SUCCESS_ORIA,
    },

    paymentSuccessful: {
        index: PathNames.PAYMENT_SUCCESSFUL,
    },

    failure: {
        index: PathNames.FAILURE,
        update: PathNames.BOOKING_UPDATE_FAILURE,
    },

    aborted: {
        index: PathNames.ABORTED,
    },

    processing: {
        index: PathNames.PROCESSING,
        amend: PathNames.PROCESSING_AMEND,
    },

    callback: {
        index: PathNames.CALLBACK,
        additionalOccupant: PathNames.DUAL_OCCUPANT_CALLBACK,
        amendBooking: PathNames.AMEND_BOOKING_CALLBACK,
        amendBookingDualOccupant: PathNames.AMEND_BOOKING_CALLBACK_DUAL_OCCUPANT,
    },

    brochureCallback: {
        index: PathNames.BROCHURE_CALLBACK,
    },

    logoutCallback: {
        index: PathNames.LOGOUT,
    },

    occupant: {
        index: PathNames.OCCUPANT,
        createPassword: PathNames.OCCUPANT_PASSWORD,
        details: PathNames.OCCUPANT_DETAILS,
    },

    roomNotAvailable: {
        index: PathNames.ROOM_NOT_AVAILABLE,
    },

    noRoomSelected: {
        index: PathNames.NO_ROOM_SELECTED,
    },

    amendBooking: {
        index: PathNames.AMEND_BOOKING,
        summary: PathNames.AMEND_BOOKING_SUMMARY,
    },

    bookingUpdated: {
        index: PathNames.BOOKING_UPDATED,
    },

    bookingUpdateExpired: {
        index: PathNames.BOOKING_UPDATE_EXPIRED,
    },

    notFound: {
        index: PathNames.NOT_FOUND,
    },

    makeAPayment: {
        index: PathNames.MAKE_A_PAYMENT,
    },

    auth: {
        resetPassword: PathNames.RESET_PASSWORD,
    },
};
